import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const aiChatBot = async (userId, request) => {
  try {
    const token = sessionStorage.getItem("authToken");
    const res = await fetch(
      `${api_base_url}/api/${api_key}/post/${userId}/SaveAi`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(
          typeof request === "string" ? { prompt: request } : request
        ),
      }
    );

    const data = await res.json();
    if (!res.ok) {
      return {
        error: true,
        status: res.status,
        message: data?.message || "AI request failed",
        usage: data?.usage || null,
      };
    }

    return {
      error: false,
      reply: data.reply,
      usage: data.usage,
    };

  } catch (err) {
    console.error("AI fetch error:", err);
    throw err;
  }
};

export const downloadChatPdf = async (userId, messageText) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(
      `${api_base_url}/api/${api_key}/post/${userId}/GetChatPdf`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ messageText })
      });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to generate PDF: ${response.statusText}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const fileName = `SAVE_AI_Report_${new Date().getTime()}.pdf`;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    console.error('API Download Error:', error);
    throw error;
  }
};
